import { LoadingSpinner } from '@tvg/fuse/loading-spinner';
import useIsUpdating from 'client/hooks/useIsUpdating';
import React from 'react';
import styles from './Spinner.module.css';

export function Spinner() {
  const isUpdating = useIsUpdating();

  if (!isUpdating) return null;
  return (
    <>
      <div className={styles.spinner__overlay} />
      <div className={styles.spinner__container}>
        <div className={styles.spinner__square}>
          <LoadingSpinner size="responsive" animationTime={1} />
        </div>
      </div>
    </>
  );
}
